import { get, post } from '@/api/core'
import {
  BackendProductServiceCategory,
  toBackendProductServiceCategory,
} from '@/helpers/productCategory'

export type AnalyseCountCategory =
  | 'quick_landscape'
  | 'base_landscape'
  | 'survey_landscape'
  | 'quick_portrait'
  | 'base_portrait'
  | 'survey_portrait'

export type UsageRecordProjectCategory =
  | 'quick_landscape'
  | 'base_landscape'
  | 'survey_landscape'
  | 'quick_portrait'
  | 'base_portrait'
  | 'survey_portrait'

export type AnalyseCountCategoryCamel =
  | 'quickLandscape'
  | 'baseLandscape'
  | 'surveyLandscape'
  | 'quickPortrait'
  | 'basePortrait'
  | 'surveyPortrait'

const PROJECT_CATEGORIES: ProjectModels.ProjectCategory[] = [
  'horizontal-quick',
  'horizontal-base',
  'horizontal-survey',
  'portrait-quick',
  'portrait-base',
  'portrait-survey',
]

export function toAnalyseCountCategory(
  projectCategory: ProjectModels.ProjectCategory | AnalyseCountCategory
): AnalyseCountCategory {
  if (!PROJECT_CATEGORIES.includes(projectCategory as ProjectModels.ProjectCategory)) {
    return projectCategory as AnalyseCountCategory
  }
  return toBackendProductServiceCategory(projectCategory as ProjectModels.ProjectCategory)
}

export namespace corp {
  export function list() {
    return get<{ corpList: Models.CorpInfo[] }>('/staff/corp_list')
  }

  /** 切换 corp */
  export function use(corpId: string) {
    return post('/staff/corp_change', {}, { corpId })
  }

  export type VersionInfoItem = {
    projectCategory: BackendProductServiceCategory
    versionName: string
    corpAnalyseCount: number
    totalCount: number
    isInfinite: boolean
    infiniteInfo: null | {
      infiniteContractStart: number
      infiniteContractEnd: number
    }
    infiniteStatus: string
    canEnter: boolean
  }

  /** 获取分析次数 */
  export function analysisCnt(params?: {
    projectCategory?: ProjectModels.ProjectCategory | AnalyseCountCategory
  }) {
    const nextParams = params?.projectCategory
      ? { ...params, projectCategory: toAnalyseCountCategory(params.projectCategory) }
      : params
    return get<{
      corpAnalyseCount: number;
      totalCount: number;
      isInfinite: boolean;
      infiniteInfo: null | {
        infiniteContractEnd: number
        infiniteContractStart: number
      }
    }>('/corp/analyse_count', nextParams)
  }

  /** 获取各产品入口次数信息 */
  export function analysisCntEntry() {
    return get<{
      versionInfoList: VersionInfoItem[]
      versionInfoMap: Record<AnalyseCountCategoryCamel, VersionInfoItem>
    }>('/corp/analyse_count/entry')
  }

  export function anaysisUsageRecord(p: {
    pageNo: number
    pageSize: number
    projectCategory?: ProjectModels.ProjectCategory | AnalyseCountCategory
  }) {
    const params = p.projectCategory
      ? { ...p, projectCategory: toAnalyseCountCategory(p.projectCategory) }
      : p
    return get<{
      hasNext: boolean
      pageNo: number
      pageSize: number
      totalCount: number
      objects: Array<{
        advertProjectId: number
        projectName: string
        projectCategory: UsageRecordProjectCategory
        staffAvatar: string
        staffName: string
        createdAt: number
        usageCount: number
      }>
    }>('/corp/analyse_count/usage_record', params)
  }

  /** 获取企业品牌基准值 */
  export function getCorpBrandNormStatus() {
    return get<{ brandNormStatus: boolean }>('/corp/brand_norm_status')
  }

  export function getCorpVideoDurationConfig(params?: {
    projectCategory?: ProjectModels.ProjectCategory | BackendProductServiceCategory
  }) {
    const nextParams = params?.projectCategory
      ? {
        ...params,
        projectCategory: PROJECT_CATEGORIES.includes(params.projectCategory as ProjectModels.ProjectCategory)
          ? toBackendProductServiceCategory(params.projectCategory as ProjectModels.ProjectCategory)
          : params.projectCategory,
      }
      : params
    return get<{
      projectCategory: BackendProductServiceCategory
      minDuration: number
      maxDuration: number
      config: {
        quickLandscape: { minDuration: number; maxDuration: number }
        base: { minDuration: number; maxDuration: number }
        survey: { minDuration: number; maxDuration: number }
        quickPortrait: { minDuration: number; maxDuration: number }
        basePortrait: { minDuration: number; maxDuration: number }
        surveyPortrait: { minDuration: number; maxDuration: number }
      }
    }>('/corp/video_duration', nextParams)
  }

  export function getCorpFreeTrialStatus(params?: {
    projectCategory?: ProjectModels.ProjectCategory | AnalyseCountCategory
  }) {
    const nextParams = params?.projectCategory
      ? { ...params, projectCategory: toAnalyseCountCategory(params.projectCategory) }
      : params
    return get<{ freeTrial: boolean, hasApply: boolean }>('/corp/free_trial/status', nextParams)
  }


  /** 申请免费试用 */
  export function applyForFreeTrial(body: {
    staffName: string,
    staffTel: string
    // 部门
    staffDepartment: string
    //职位
    staffPosition: string
    // 企业名称
    corpName: string,
    country: string
    city: string
  }) {
    return post('/corp/free_trial/apply', {}, body)
  }

  export function changeCorpName(body: { corpName: string }) {
    return post('/corp/name/update', {}, body)
  }

  export function bindAgentCode(body: { referralCode: string }) {
    return post('/corp/agent/bind', {}, body)
  }


  export function getBindAgentCode() {
    return get<{ code: string }>('/corp/bind_agent/code')
  }

}
